import { Pipe } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
/**
 * @deprecated use v3 version of this component instead
 */
export class SortByNamePipe {
  translate;
  constructor(translate) {
    this.translate = translate;
  }
  transform(options) {
    if (!options) return options;
    return options.sort((a, b) => {
      const nameA = this.getTranslatedName(a.name);
      const nameB = this.getTranslatedName(b.name);
      return nameA.localeCompare(nameB);
    });
  }
  getTranslatedName(name) {
    return this.translate.instant(name ?? '');
  }
  static ɵfac = function SortByNamePipe_Factory(t) {
    return new (t || SortByNamePipe)(i0.ɵɵdirectiveInject(i1.TranslateService, 16));
  };
  static ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
    name: "sortByName",
    type: SortByNamePipe,
    pure: false,
    standalone: true
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SortByNamePipe, [{
    type: Pipe,
    args: [{
      name: 'sortByName',
      standalone: true,
      pure: false
    }]
  }], () => [{
    type: i1.TranslateService
  }], null);
})();
